'use strict';

var isSymbol = require('./is-symbol');

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es6-symbol/validate-symbol.js
 ** module id = 203
 ** module chunks = 0
 **/